<template>
  <el-dialog width="400px" title="创建会话" @close="closeSelected" :visible.sync="dialogVisible">
    <el-card class="chat-card" shadow="never">
      <div slot="header" class="card_header">
        <span>选择干系人</span>
        <el-button style="float: right; padding: 3px 0" @click="addTaskMember" type="text">添加干系人</el-button>
      </div>
      <div class="taskUser_div">
        <iframe style="display:none;" :src="imSrc"></iframe>
        <el-tree
          show-checkbox
          class="tree_checkbox"
          ref="tree"
          node-key="ID"
          :data="userSource"
          :props="{
               label: 'USERNAME',
                }"
        ></el-tree>
      </div>
    </el-card>

    <!-- <el-transfer filterable
                 class="transfer_taskUser"
                 :titles="['未选', '已选']"
                 :format="{
                  noChecked: '${total}',
                  hasChecked: '${checked}/${total}'
                  }"
                 :props="{
                  key: 'ID',
                  label: 'USERNAME'
                  }"
                 filter-placeholder="模糊查找..."
                 v-model="selectedUserList"
                 :data="userSource">
      <el-button class="transfer-footer"
                 slot="left-footer"
                 size="small">添加干系人</el-button>
      <el-row class="transfer-footer"
              slot="right-footer"></el-row>
    </el-transfer>-->
    <span slot="footer" class="dialog-footer">
      <allUserDialog
        ref="allUserDialog"
        :isRadio="false"
        @assignmentInput="toGetValue"
        :userId="userId"
      ></allUserDialog>
      <el-checkbox label="全选" border v-model="checkAll" @change="changeAll"></el-checkbox>
      <el-button type="primary" @click="sureGroup">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </span>

    <el-dialog width="400px" title="创建群名称" @close="groupClose" :visible.sync="groupShow" :append-to-body="true">
      
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px">
        <el-form-item label="群名称" prop="groupName">
          <el-input v-model="ruleForm.groupName" placeholder="请输入群名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="createNewSession('ruleForm')">确 定</el-button>
          <el-button @click="groupClose">取 消</el-button>
        </el-form-item>
      </el-form>
      
    </el-dialog>

  </el-dialog>
</template>

<script>
import { getToken } from "@/util/auth";
import allUserDialog from "@/components/basicTemplate/allUserDialog.vue";
import {
  GetTaskMemeber,
  AddTaskMemberList,
  DelTaskMemeber,
  UpdateTaskMemberList
} from "@/api/modules/basicData/task";
const cookieUser = getToken();
export default {
  props: {
    taskId: {
      type: String,
      default: ""
    }
  },
  components: {
    allUserDialog
  },
  data() {
    return {
      dialogVisible: false,
      userSource: [],
      userId: cookieUser.userId,
      imSrc: "",
      checkAll: false,
      groupShow:false,//新增群组名称
      ruleForm:{
        groupName:'',//群名称
      },
      rules: {
          groupName: [
            { required: true, message: '请输入群名称', trigger: 'blur' },
            { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
          ],
      }
    };
  },
  watch: {
    taskId(newValue) {
      GetTaskMemeber(newValue, false).then(res => {
        if (!res) return;
        this.userSource = res;
      });
    }
  },
  methods: {
    changeAll(val) {
      console.log("changeAll", val);
      if (val) {
        this.$refs.tree.setCheckedNodes(this.userSource);
      } else {
        this.$refs.tree.setCheckedNodes([]);
      }
    },
    toGetValue(value) {
      console.log("输出UserID", value);
      let idArray = this.userSource.map(u => u.USERID);
      console.log("idArray", idArray);
      let addArray = value
        .filter(f => idArray.indexOf(f.Id) === -1)
        .map(item => {
          return {
            TASKID: this.taskId,
            USERID: item.ID,
            USERNAME: item.Name,
            DEPTID: item.DeptId,
            DEPTNAME: item.DeptName,
            USERTYPE: 1,
            ISNOTICEPERSON: false,
            ALLOWCREATESUBTASK: true,
            FIXEDMEMEBER: false
          };
        });
      console.log(addArray);
      if (addArray.length > 0)
        AddTaskMemberList(addArray).then(result => {
          if (result > 0) {
            console.log(result);
            this.userSource = this.userSource.concat(addArray);
          }
        });
    },
    closeSelected() {
      console.log("closeSelected");
      this.$refs.tree.setCheckedNodes([]);
      this.$refs.allUserDialog.reset();
      this.checkAll = false;
    },
    groupClose(){//群名名称弹窗关闭
      this.groupShow=false;
    },
    //选择会话
    addTaskMember() {
      this.$refs.allUserDialog.OpenDialog([]);
      //  this.$refs.selectAllUser.dialogVisible = true;
    },
    sureGroup(){//群组名称开启
    
       let rows = this.$refs.tree.getCheckedNodes();
       let userId = rows.map(item => item.USERID).join(",");
       if(userId){
         this.groupShow=true;
       }else{
         this.$message.warning("请选择干系人")
       }
    },
    //创建新回话
    createNewSession(formName) {
      let that=this;
      this.$refs[formName].validate((valid) => {
          if (valid) {
            let rows = that.$refs.tree.getCheckedNodes();
            let userId = rows.map(item => item.USERID).join(",");
            let url = `RedCoral://IM/?usercode=${cookieUser.account}&users=${userId}&taskId=${that.taskId}&groupName=${that.ruleForm.groupName}&sessionId=0&chatType=2`;
            window.protocolCheck(url, () => {
              that.$message.warning("协议未注册");
            });
            that.imSrc = url;
            that.dialogVisible = false;
            that.groupShow=false;
          } else {
            console.log('error submit!!');
            return false;
          }
      })
      
    }
  }
};
</script>

<style scoped>
.chat-card .el-card__header {
  background: #f4f7f9;
  padding: 10px !important;
}
.tree_checkbox .el-checkbox {
  margin-right: 8px;
}
</style>
<style scoped>
/* .transfer_taskUser .el-checkbox-group {
  display: flex;
  flex-direction: column;
} */

.taskUser_div {
  display: flex;
  flex-direction: column;
  border: 1px;
}
</style>